<template>
  <div id="largescreen" :style="_isMobile() ? {} : largescreenPcStyle">
    <div class="bg_main">
      <el-row :gutter="10">
        <el-col :lg="24" :md="24" :sm="24" :xs="24">
          <top-header title="销售平台驾驶舱" />
        </el-col>
      </el-row>
      <el-row :gutter="15" class="padding-tlr">
        <el-col :lg="7" :md="7" :sm="24" :xs="24">
          <left-1 class="card_item_bg" />
          <left-2 class="card_item card_item_bg" />
          <left-3 class="card_item card_item_bg" />
          <left-4 class="card_item card_item_bg" />
          <left-5 class="card_item card_item_bg" />
        </el-col>
        <el-col :lg="10" :md="10" :sm="24" :xs="24">
          <center-1 class="card_item_bg" />
          <center-2 class="card_item card_item_bg" />
          <center-3 class="card_item card_item_bg" />
          <center-4 class="card_item card_item_bg" />
          <center-5 class="card_item card_item_bg" />
          <center-6 class="card_item card_item_bg" />
        </el-col>
        <el-col :lg="7" :md="7" :sm="24" :xs="24">
          <right-1 class="card_item_bg" />
          <right-2 class="card_item card_item_bg" />
          <right-3 class="card_item card_item_bg" />
          <right-4 class="card_item card_item_bg" />
          <right-5 class="card_item card_item_bg" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import TopHeader from "../components/topHeader";
import Left1 from "./components/left/left_1";
import Left2 from "./components/left/left_2";
import Left3 from "./components/left/left_3";
import Left4 from "./components/left/left_4";
import Left5 from "./components/left/left_5";
import Center1 from "./components/center/center_1";
import Center2 from "./components/center/center_2";
import Center3 from "./components/center/center_3";
import Center4 from "./components/center/center_4";
import Center5 from "./components/center/center_5";
import Center6 from "./components/center/center_6";
import Right1 from "./components/right/right_1";
import Right2 from "./components/right/right_2";
import Right3 from "./components/right/right_3";
import Right4 from "./components/right/right_4";
import Right5 from "./components/right/right_5";
export default {
  name: "index",
  components: {
    TopHeader,
    Left1,
    Left2,
    Left3,
    Left4,
    Left5,
    Center1,
    Center2,
    Center3,
    Center4,
    Center5,
    Center6,
    Right1,
    Right2,
    Right3,
    Right4,
    Right5,
  },
  data() {
    return {
      largescreenPcStyle: {
        position: "fixed",
        top: 0,
        left: 0,
      },
    };
  },
};
</script>

<style scoped lang="scss">
::v-deep#largescreen {
  height: 100%;
  width: 100%;
  background-size: 100% 100%;
  padding: 0;
  // background-image: url("../../assets/images/largescreen/home-bg1.jpg");
  overflow-y: auto;
  overflow-x: hidden;
  .bg_main {
    background: #111111;
    // background: rgba(125, 155, 243, 0.2);
  }
  .el-col {
    height: 100%;
    position: relative;
  }
  .padding-tlr {
    padding: 10px 10px 0;
    .card_item {
      margin-top: 18px;
    }
  }
  .padding-lr {
    padding: 0 10px 0;
  }
  .card_item_bg {
    background: rgba(28, 124, 232, 0.05);
  }
}
</style>
